<button
  class="btn btn-sm ca-btn ca-btn-neutral-command"
  (click)="onClickDuplicate($event)"
  ngbTooltip="{{ '::Duplicate' | abpLocalization }} (Shift + Enter)"
  container="body"
  placement="left">
  <i class="far fa-copy"></i>
</button>
